export default __webpack_public_path__ + "static/media/flax seeds.19d80fe3.jpg";